/**
 * «Что нового» (§10, M5).
 *
 * Показывается один раз на выпуск и только тому, кто приложением уже
 * пользовался. Новичку рассказывать, «что изменилось», не о чем: он ничего
 * не застал, и такой экран для него — просто препятствие на входе. Признак
 * «уже пользовался» — хотя бы одна закрытая подсказка первого входа.
 *
 * Шторка, а не отдельный экран: человек открыл приложение по делу, и новости
 * не должны вставать между ним и делом дольше, чем на один тап.
 */

import { useMarkHints } from '@/shared/api/hints'
import { formatDate } from '@/shared/format'
import { useRole, useTimeZone } from '@/app/session'
import { Button } from '@/shared/ui/Button'
import { Icon } from '@/shared/ui/Icon'
import { Sheet } from '@/shared/ui/Sheet'
import { useUnreadReleases } from '@/features/whatsnew/releases'

export function WhatsNew() {
  const mark = useMarkHints()
  const timeZone = useTimeZone()
  const unread = useUnreadReleases(useRole())

  if (unread.length === 0) return null

  const close = () => mark.mutate(unread.map((release) => release.key))

  return (
    <Sheet
      open
      onClose={close}
      title="Что нового"
      footer={
        <Button block size="lg" onClick={close} loading={mark.isPending}>
          Понятно
        </Button>
      }
    >
      {unread.map((release) => (
        <section key={release.key} className="mb-5 last:mb-0">
          <div className="flex items-baseline justify-between gap-3">
            <h3 className="font-display text-lead leading-tight">{release.title}</h3>
            <span className="text-text-muted shrink-0 text-caption">
              {formatDate(release.date, timeZone)}
            </span>
          </div>

          <ul className="mt-3 space-y-3">
            {release.items.map((item) => (
              <li key={item.text} className="flex gap-3">
                <span className="bg-accent-soft flex size-9 shrink-0 items-center justify-center rounded-[var(--radius-tile)]">
                  <Icon name={item.icon} size={22} />
                </span>
                <p className="text-text-muted pt-1 text-note leading-snug">{item.text}</p>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </Sheet>
  )
}
